import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

const ProtectedAdminRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner">
          <div className="spinner"></div>
          <p>Verifying permissions...</p>
        </div>
      </div>
    );
  }

  // Check if user is logged in
  if (!user) {
    return (
      <Navigate
        to="/"
        replace
      />
    );
  }

  // Check if user has admin role (role >= 2, excluding lawyers with role = 1)
  if (user.role < 2) {
    return (
      <div className="access-denied">
        <div className="access-denied-content">
          <h1>Access Denied</h1>
          <p>You don't have permission to access this page.</p>
          <p>This area is restricted to Administrators only.</p>
          <button
            onClick={() => window.history.back()}
            className="btn-primary">
            Go Back
          </button>
        </div>
      </div>
    );
  }

  return children;
};

export default ProtectedAdminRoute;
